import { RoomBlockHotel } from './RoomBlockHotel';

export default RoomBlockHotel;
